import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { withTranslation } from "react-i18next";

import axios from "../../components/Axios";

// Billing > Invoices: past payments, with links to each invoice and Stripe receipt
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      items: [],
    };
  }

  componentDidMount() {
    // the printable invoice (pages/Invoice.js) starts from this address until the user edits it
    let b = localStorage.getItem("billing_address");
    if (b == null) {
      localStorage.setItem("billing_address", "Your Company\nYour Address");
    }

    this.getItems();
  }

  async getItems() {
    this.setState({ loading: true, items: [] });
    let resp = await axios.get("/user/stripe/transactions");
    this.setState({ loading: false, items: resp.data.data });
  }

  formatDate(u) {
    let d = new Date(u);
    return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  }

  async getReceipt(id, e) {
    e.preventDefault();
    let resp = await axios.get("/user/stripe/charge/" + id);

    if ("data" in resp.data && resp.data.data.length > 0) {
      window.open(resp.data.data[0].receipt_url);
    }
  }

  render() {
    const { t } = this.props;
    const { loading, items } = this.state;

    return (
      <section className="ac-card" aria-labelledby="ac-invoices-h">
        <div className="ac-head">
          <h2 id="ac-invoices-h" className="ac-title">
            {t("Invoices")}
          </h2>
          {!loading && <span className="ac-badge">{items.length}</span>}
        </div>
        {loading && <CircularProgress size={24} />}
        {!loading && items.length === 0 && <div className="ac-empty">{t("No payments yet")}</div>}
        {items.length > 0 && (
          <div className="ac-scroll">
            <table className="ac-table">
              <thead>
                <tr>
                  <th scope="col">{t("Date")}</th>
                  <th scope="col" className="ac-r">
                    {t("Amount")}
                  </th>
                  <th scope="col" />
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    <td>{this.formatDate(item.created * 1000)}</td>
                    <td className="ac-r">
                      {(item.amount / 100).toFixed(2)} {(item.currency || "usd").toUpperCase()}
                    </td>
                    <td className="ac-r ac-actions">
                      <a className="ac-link" href={"/invoice/" + (item.invoice === null ? item.id : item.invoice)} target="_blank" rel="noopener noreferrer">
                        {t("Invoice")}
                        <OpenInNewIcon />
                      </a>
                      <button type="button" className="ac-link" onClick={this.getReceipt.bind(this, item.id)}>
                        {t("Receipt")}
                        <OpenInNewIcon />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    );
  }
}

export default withTranslation()(Index);
